import React from 'react';
import { connect } from 'react-redux';
// Level editor imports
import { itemSelectorOpenCategory, toggleBackgroundMode } from '../../../../../../actions/levelEditorActions';
import { setActiveSidebarItem } from '../../../../../../actions/sideBarActions';
import { LevelEditorModeEnum, SideBarItems } from '../../../../../../shared';
import gameKit from '../../../../../../../GameKit';

class PrefabCategory extends React.Component {
    handleClick = () => {
        const { dispatch, levelEditor, title } = this.props;
        if (levelEditor.mode === LevelEditorModeEnum.BACKGROUND) {
            gameKit.levelEditor.exitTileMode();
            dispatch(toggleBackgroundMode());
            dispatch(setActiveSidebarItem(SideBarItems.NONE));
        }
        dispatch(itemSelectorOpenCategory(title));
    };

    render = () => {
        const { levelEditor, title } = this.props;
        const activeClass = levelEditor.itemSelectorCurrentCategory === title ? 'active' : '';

        return <input className={`prefab-category ${activeClass}`} type="button" value={title} onClick={this.handleClick} />;
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrefabCategory);
